import {InjectionToken} from '@angular/core'

export const LOCAL_STORAGE = new InjectionToken<Storage>('localStorage')

export const WINDOW = new InjectionToken<Window>('window')

/**
 * Random variables used in the app
 */
export const LOGIN_ROUTE_PATH = 'login'
export const SCAN_ROUTE_PATH = 'start'
export const USER_ROLE = 'idUser'